<template>
    <div class="todayTopic">
        <h3>今日选题</h3>
        <ul v-if="dataList.length > 0">
            <li v-for="(item, index) in dataList" :class="[dataListIndex===index ? 'on': '', 'clearBoth']">
                <a class="clearBoth" @click="toDetail(item.group, item.title)">
                    <i>{{ pageSize * (currentPage - 1) + index + 1 }}</i>
                    <h4>{{ item.title }}</h4>
                    <div class="clearBoth">
                        <span>{{ item.group }}</span>
                        <span>{{ item.userName }}</span>
                    </div>
                </a>
            </li>
        </ul>
        <el-pagination
                :page-size="pageSize"
                :current-page="currentPage"
                :pager-count="pagerCount"
                @current-change="currentChange"
                layout="prev, pager, next"
                :hide-on-single-page="hide"
                :total="total">
        </el-pagination>
    </div>


</template>

<script>
    export default {
        name: "todayTopic",
        data() {
            return {
                pageSize: 5,
                currentPage: 1,
                total: 5,
                pagerCount: 5,
                hide: true,
                dataListIndex: 0,//从第一个开始高亮显示
                allData: [],
                dataList:[],

                timer: null,
                interval:null, //轮播定时器
                loadingFlag:true,
            }
        },
        mounted() {
            this.getDataList();
            this.timer =setInterval(() => {
                this.getDataList();
            }, 1000*60*15);

            this.intervalInit();
        },
        methods: {
            getDataList(){
                let _that = this;
                _that.loadingFlag = true;
                this.axios.get('/bigscreen/jinriliebiao_list.json').then(res => {
                    this.allData = res.data.data;
                    this.total = res.data.data.length;
                    this.dataList = this.allData.slice((this.currentPage - 1) * this.pageSize, this.currentPage*this.pageSize);
                    // console.log(res);
                    _that.loadingFlag = false;
                })
            },
            currentChange(index){
                this.currentPage = index;
                this.dataList = this.allData.slice((this.currentPage - 1) * this.pageSize, this.currentPage*this.pageSize);
            },
            toDetail(group, title) {
                this.$router.push({path:'/detail', query: {type: 'getDateDetail', group: group, title: title}});
            },
            //定时器
            intervalInit(){
                let _that = this;
                clearInterval(_that.interval);
                _that.interval = setInterval(function () {
                    //数据请求完成
                    if (!_that.loadingFlag){
                        _that.dataListIndex ++;
                        if (_that.dataListIndex >= _that.dataList.length){
                            _that.dataListIndex = 0;
                        }
                    }
                },5000)
            },
        },
        // 页面销毁前
        beforeDestroy(){
            clearInterval(this.interval);
            clearInterval(this.timer);
        }
    }
</script>

<style scoped>
    .todayTopic{
        background: url("../../assets/images/todayTopicBG.png") center center no-repeat;
        background-size: 100% 100%;
        width: 760px;
        height: 866px;
        position: relative;
        box-sizing: border-box;
        padding: 87px 30px 62px 51px;
    }
    .todayTopic h3{
        font-size: 42px;
        position: absolute;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
        font-weight: normal;
        font-family: hyk1gj;
    }
    ul li {
        padding: 26px 0;
    }
    ul li.on{
         background-image: linear-gradient(to right, rgba(7, 12, 21 , 0.8), rgba(75, 43, 36, 1));
    }
    ul li.on h4{
        color: #eacb42;
    }
    ul li.on i{
        background: url("../../assets/images/todayTopicIndexBgOn.png") center center no-repeat;
        background-size: 100% 100%;
    }
    ul li h4{
        font-size: 32px;
        line-height: 32px;
        margin-bottom: 26px;
        float: right;
        width: calc(100% - 104px);
        color: #fff;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    ul li i{
        float: left;
        width: 74px;
        height: 74px;
        display: flex;
        margin-right: 30px;
        justify-content: center;
        align-items: center;
        color: #000;
        background: url("../../assets/images/todayTopicIndexBg.png") center center no-repeat;
        background-size: 100% 100%;
    }
    ul li a {
        display: block;
        width: 100%;
        height: 100%;
    }
    ul li a div{
        float: right;
        width: calc(100% - 104px);
    }
    ul li span{
        font-size: 28px;
        color: #88b5fb;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 50%;
        line-height: 28px;
        float: left;
    }


</style>
